/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRuleApplyRequest {
    getFixupPrototypeFunction() { return RecommendationExclusionRuleApplyRequest.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRuleApplyRequest>): RecommendationExclusionRuleApplyRequest {
        let obj = Object.assign(new RecommendationExclusionRuleApplyRequest(), model);
        RecommendationExclusionRuleApplyRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRuleApplyRequest>): RecommendationExclusionRuleApplyRequest {
        if (!model) return null;
        return RecommendationExclusionRuleApplyRequest.newInstance(<RecommendationExclusionRuleApplyRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRuleApplyRequest) {
        if (!obj) return;

        models.RecommendationExclusionRuleApplyRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRuleApplyRequest): boolean {
        Object.setPrototypeOf(obj, RecommendationExclusionRuleApplyRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Rules to apply on provided tenant.
     */
    tenant_id: string;

}
